// eslint-disable-next-line import/no-unresolved
import Delegate from 'ftdomdelegate';
import inputCharLength from './input-char-length';
import ErrorMesssage from './error-message';

class ValidateInput {
	constructor(config) {
		this.config = config;
		this.inputElement = document.querySelector(`#${this.config.inputId}`);
		this.delegate = new Delegate(document.body);
		this._reactOnValidation = this._reactOnValidation.bind(this);
		this.submitRequested = false;
	}

	get inputForm() {
		return document.querySelector(this.config.inputFormSelector);
	}

	_reactOnValidation(event) {
		const inputValidates = inputCharLength(this.config.inputId);
		let wannaSubmit = false;

		if (event.type === 'submit') {
			wannaSubmit = true;
			event.preventDefault();
		}

		const errorMesssage = new ErrorMesssage({
			inputElementId: this.config.inputId,
			inputErrorClass: 'c-inputgroup__input--errored',
			errorMesssageClass: 'c-inputgroup__validation-text c-inputgroup__validation-text--errored',
			errorText: 'Choose a password that is 6 to 20 characters long.'
		});
		errorMesssage.init(inputValidates);

		if (inputValidates && wannaSubmit) {
			this.inputForm.submit();
		}
	}

	init() {
		if (this.inputElement === null || this.inputElement === undefined) {
			return;
		}
		// this will skip html5 validation
		this.inputForm.setAttribute('novalidate', '');

		this.delegate.on('change', `#${this.config.inputId}`, this._reactOnValidation);
		this.delegate.on('submit', this.config.inputFormSelector, this._reactOnValidation);
	}
}

export default ValidateInput;
